import PropTypes from 'prop-types'
import React from 'react'

import { FILES } from '../../config'

import KununuStars from './KununuStars'

const KununuWidget = ({ score }) => (
  <div className='kununu-score-section qa-kununu-score-section'>
    <div className='score-section-left'>
      <span className='score-value'>{score.toFixed(1)}</span>
    </div>
    <div className='score-section-right'>
      <KununuStars score={score} className='score-stars' />
      <div className='kununu-powered'>
        <span className='powered-by'>Powered by&nbsp;</span>
        <img alt='Kununu' src={FILES.KUNUNU_LOGO_SEARCH} width='42' height='10' />
      </div>
    </div>
  </div>
)

KununuWidget.propTypes = {
  score: PropTypes.number.isRequired
}

export default KununuWidget
